import { Colors, Metrics, Typography } from "../../resources";
import { Orientation, SIconType } from "../../types";
import { StyleSheet, Text, View } from "react-native";

import React from "react";
import SIcon from "./SIcon";
import SSpacer from "./SSpacer";

interface IProps {
  type: SIconType;
  title: string;
}

const STitle: React.FC<IProps> = ({ title, type }) => {
  return (
    <View style={styles.container}>
      <SIcon type={type} size={Metrics.iconMedium} />
      <SSpacer type={Orientation.Horizontal} space={Metrics.padding6} />
      <Text style={styles.title}>{title}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  title: {
    ...Typography.headline0,
    fontSize: 18,
    color: Colors.midnight,
  },
});

export default STitle;
